// Última modificación: 27/10/2025

/**
 * Sort the result by the indicated attribute
 * @default "RECORDISSUED"
 */
export enum DatasetFilterDtoV2SortByEnum {
	TITLE = "TITLE",
	DESCRIPTION = "DESCRIPTION",
	LANGUAGE = "LANGUAGE",
	OWNER = "OWNER",
	PUBLISHER = "PUBLISHER",
	CREATED = "CREATED",
	ACCESSRIGHTS = "ACCESSRIGHTS",
	RECORDTITLE = "RECORDTITLE",
	RECORDDESCRIPTION = "RECORDDESCRIPTION",
	RECORDISSUED = "RECORDISSUED",
	RECORDCREATOR = "RECORDCREATOR",
}
